import PasswordVerificationCard from "components/myInfo/PasswordVerificationCard/PasswordVerificationCard";
import PasswordVerificationMobileCard from "components/myInfo/PasswordVerificationCard/PasswordVerificationMobileCard";
import UserProfileFormCard from "components/myInfo/UserProfileFormCard/UserProfileFormCard";
import useMediaView from "features/common/hooks/useMediaView";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

interface FormData {
  password: string;
}

const MypageInformationPage = () => {
  const [isValid, setIsValid] = useState(false);
  const isMobile = useMediaView("small");

  const method = useForm<FormData>();

  const handlePasswordValidationSuccess = () => {
    // 비밀번호 검증 로직
    setIsValid(true);
  };

  if (!isValid && !isMobile)
    return (
      <FormProvider {...method}>
        <PasswordVerificationCard onSuccess={handlePasswordValidationSuccess} />
      </FormProvider>
    );
  if (!isValid && isMobile) {
    return (
      <FormProvider {...method}>
        <PasswordVerificationMobileCard
          onSuccess={handlePasswordValidationSuccess}
        />
      </FormProvider>
    );
  }

  return (
    <>
      <UserProfileFormCard password={method.getValues("password")} />
    </>
  );
};

export default MypageInformationPage;
